import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { GenerateSuperadminOTP, HeaderComponent } from './layout/header/header.component';
import { PageLoaderComponent } from './layout/page-loader/page-loader.component';
import { SidebarComponent } from './layout/sidebar/sidebar.component';
import { AuthLayoutComponent } from './layout/app-layout/auth-layout/auth-layout.component';
import { MainLayoutComponent } from './layout/app-layout/main-layout/main-layout.component';
// import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { fakeBackendProvider } from './core/interceptor/fake-backend';
import { ErrorInterceptor } from './core/interceptor/error.interceptor';
import { JwtInterceptor } from './core/interceptor/jwt.interceptor';
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { CommonComponentsModule } from './common-components/common-components.module';
import { MatChipsModule } from '@angular/material/chips';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LanguageComponent } from './layout/language/language.component';
import { SwitchCompanyComponent } from './layout/header/switch-company/switch-company.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { MentionModule } from 'angular-mentions';
import { SuperadminSidebarComponent } from './superadmin/layout/sidebar/sidebar.component';
import { SuperadminAuthLayoutComponent } from './superadmin/layout/app-layout/auth-layout/auth-layout.component';
import { SuperadminMainLayoutComponent } from './superadmin/layout/app-layout/main-layout/main-layout.component';
import { SuperadminHeaderComponent } from './superadmin/layout/header/header.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { SupportOtpComponent } from './superadmin/client/client-form/support-otp/support-otp.component';
import { NgOtpInputModule } from 'ng-otp-input';
import { RightSidebarComponent } from './layout/right-sidebar/right-sidebar.component';
import { ProcessCompleteDialogComponent } from './process-complete-dialog/process-complete-dialog.component';
import { MomentModule } from 'ngx-moment';
import { MatSelectFilterModule } from '@devlukaszmichalak/mat-select-filter';
import { MatOptionModule } from '@angular/material/core';

@NgModule({
    declarations: [
        LandingPageComponent,
        ProcessCompleteDialogComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        NgScrollbarModule,
        ReactiveFormsModule,
        LoadingBarRouterModule,
        // core & shared
        CoreModule,
        SharedModule,
        CommonComponentsModule,
        MatSelectFilterModule,
        MatChipsModule,
        MatDialogModule,
        MatSnackBarModule,
        MatBadgeModule,
        MomentModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: httpTranslateLoader,
                deps: [HttpClient],
            },
        }),
        MatAutocompleteModule,
        InfiniteScrollModule,
        MentionModule,
        NgOtpInputModule,
        MatOptionModule], providers: [
            // { provide: LocationStrategy, useClass: HashLocationStrategy },
            { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
            { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
            fakeBackendProvider,
            provideHttpClient(withInterceptorsFromDi()),
        ]
})
export class AppModule { }
// AOT compilation support
export function httpTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http);
}
